<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters pb-2">
        <v-col cols="12" sm="6" md="6" lg="3">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
            hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="4">
          <v-select solo v-model="selectedContest" :items="getAllNames" item-text="contest_name" item-value="contest_id"
            append-icon="mdi-chevron-down" label="All Contest" class="custom-select"
            @change="handleContestChange"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="2">
          <v-select solo v-model="selectedtStatus" :items="filterslots" @change="handleContestStatus"
            append-icon="mdi-chevron-down" label="Approval Status" class="custom-select"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="3">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="dateRange" width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="selectedDatesText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down"
                readonly v-bind="attrs" v-on="on" solo class="custom-select" label="Date Range"></v-text-field>
            </template>
            <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
              <v-spacer></v-spacer>
              <v-btn text @click="cancelSelection">Cancel</v-btn>
              <v-btn text @click="confirmSelection">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable " :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <v-data-table :headers="headers" :search="search" :items-per-page="5" :items="allrunningparticipants">
          <template v-slot:item.action="{ item }">
            <div class="status-selection">
              <v-select solo :items="slots" append-icon="" class="custom-select" :value="item.status" item-text="text"
                item-value="value" readonly disabled>
                <template v-slot:selection="{ item: selectedItem }">
                  <div :class="getTextColor(selectedItem)">
                    {{ selectedItem.text }}
                  </div>
                </template>
              </v-select>
            </div>
          </template>

          <template v-slot:item.ContestName="{ item }">
            <span class="d-block text-truncate" style="max-width: 80px;">
              {{ item.contest_name }}
            </span>
          </template>

          <template v-slot:item.sl="{ index }">
            {{ index + 1 }}
          </template>

          <template v-slot:item.deposit_date="{ index }">
            {{ formatMySQLDate(item?.deposit_date)}}
          </template>

          <template v-slot:item.ParticipantName="{ item }">
            <span class="d-block text-truncate" style="max-width: 80px;">
              {{ item.name }}
            </span>
          </template>

          <template v-slot:item.details="{ item }">
            <v-dialog transition="scale-transition" origin="center center" max-width="985px"
              v-model="depositModal[item.id]" content-class="deposit-modal">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <img width="50px" :src="item.payment_slip" alt="trx" />
                </span>
              </template>

              <template>
                <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" class="deposit-form">
                  <v-btn class="close-btn" icon dark @click="handleClose(item)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>

                  <v-card-title>
                    <div class="image-details">
                      <v-img src="@/assets/bank-transfer.png"></v-img>
                      <h3>Bank Transfer</h3>
                    </div>
                    <div class="content-details">
                      <h3>Deposit:</h3>
                      <span>${{ item.amount }}</span>
                    </div>
                  </v-card-title>

                  <v-card-text>
                    <iframe :src="item.payment_slip" width="100%" height="400px" title="payment proof"></iframe>
                  </v-card-text>

                  <v-card-subtitle>
                    <div class="download-icon">
                      <p>Download</p>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M1.28906 5L1.28906 2.33333C1.28906 1.97971 1.42954 1.64057 1.67959 1.39052C1.92964 1.14048 2.26877 1 2.6224 1L11.9557 1C12.3094 1 12.6485 1.14048 12.8985 1.39052C13.1486 1.64057 13.2891 1.97971 13.2891 2.33333L13.2891 5"
                          stroke="#039de9" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3.95443 9.66602L7.28776 12.9993L10.6211 9.66602" stroke="#039de9"
                          stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.28516 13.002L7.28516 5.00195" stroke="#039de9" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </div>
                    <div class="tab-details">
                      <p>Open In New Tab</p>
                      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2033_47716)">
                          <path
                            d="M1.12305 9.99967C1.12305 9.99967 4.45638 3.33301 10.2897 3.33301C16.123 3.33301 19.4564 9.99967 19.4564 9.99967C19.4564 9.99967 16.123 16.6663 10.2897 16.6663C4.45638 16.6663 1.12305 9.99967 1.12305 9.99967Z"
                            stroke="#039de9" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M10.2891 12.5C11.6698 12.5 12.7891 11.3807 12.7891 10C12.7891 8.61929 11.6698 7.5 10.2891 7.5C8.90835 7.5 7.78906 8.61929 7.78906 10C7.78906 11.3807 8.90835 12.5 10.2891 12.5Z"
                            stroke="#039de9" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_2033_47716">
                            <rect width="20" height="20" fill="white" transform="translate(0.289062)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </v-card-subtitle>

                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <h1>All Information</h1>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Name</legend>
                          <v-text-field v-model="item.name" single-line solo hide-details class="custom-select"
                            readonly></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Email</legend>
                          <v-text-field v-model="item.email" single-line solo hide-details class="custom-select"
                            readonly></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Account No</legend>
                          <v-text-field v-model="item.account_no" single-line solo hide-details class="custom-select"
                            readonly></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Transaction Method</legend>
                          <v-text-field value="Bank Transfer" single-line solo hide-details class="custom-select"
                            readonly></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Amount</legend>
                          <v-text-field :value="'$' + item.amount" single-line solo hide-details class="custom-select"
                            readonly></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Time</legend>
                          <v-text-field v-model="item.created_at" single-line solo hide-details class="custom-select"
                            readonly></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Status</legend>
                          <v-text-field :value="getStatusText(item.status)" single-line solo hide-details
                            class="custom-select" readonly></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Country</legend>
                          <v-text-field v-model="item.country" single-line solo hide-details class="custom-select"
                            readonly></v-text-field>
                        </fieldset>
                      </v-col>
                    </v-row>

                    <v-row v-if="showButtons">
                      <v-col cols="6">
                        <div class="button-wrapper">
                          <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                            color="greenMain" @click="approveParticipant(item)">
                            Approved
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="button-wrapper">
                          <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                            color="#FF567F" @click="showRejectionForm(item)">
                            Rejected
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row v-if="showRejectionCauseSection">
                      <v-col cols="12">
                        <h2>Rejection Cause</h2>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Reason</legend>
                          <v-select v-model="selectedReason" solo :items="rejectionReasons"
                            append-icon="mdi-chevron-down" label="Click to select" class="custom-select"
                            hide-details></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" v-if="selectedReason === 'Other'">
                        <fieldset>
                          <legend>Write Your Reason</legend>
                          <v-text-field v-model="customReason" single-line label="Write Here" solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="6">
                        <div class="button-wrapper">
                          <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                            color="#FF567F" @click="confirmReject(item)">
                            Confirm Reject
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="button-wrapper">
                          <v-btn small tile elevation="0" block outlined class="ma-0 text-capitalize btn-account py-4"
                            @click="cancelRejection">
                            Cancel
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </v-dialog>
          </template>
        </v-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import { formatMySQLDate } from '@/_helpers/formateDate';
import toast from '@/services/Notification';
import { CONTEST__ACTIONS } from "@/store/action-types";
import { mapActions } from "vuex";

export default {
  name: 'ContestParticipants',
  props: {
    allrunningparticipants: {
      type: Array,
      required: true
    }
  },

  computed: {
    getAllNames() {
      const allOption = { contest_name: 'All Contests', contest_id: null }

      const contests = this.allrunningparticipants.reduce((acc, item) => {
        if (item.contest_name && !acc.find(c => c.contest_id === item.contest_id)) {
          acc.push({
            contest_name: item.contest_name,
            contest_id: item.contest_id
          })
        }
        return acc
      }, [])

      return [allOption, ...contests]
    }
  },

  data() {
    return {
      depositModal: {},
      selectedContest: null,
      selectedtStatus: '',
      selectedDates: [],
      selectedDatesText: null,

      showRejectionCauseSection: false,
      showButtons: true,
      selectedReason: null,
      customReason: "",

      search: "",

      headers: [
        { text: "Contest No.", align: "center", value: "sl" },
        { text: "Contest Name", value: "contest_name" },
        { text: "Participant Name", value: "ParticipantName" },
        { text: "Email", value: "email" },
        { text: "Trading Acc.", value: "trading_acc" },
        { text: "Deposit Date", value: "deposit_date" },
        { text: "De.Amount", value: "amount" },
        { text: "De.Proof", value: "details" },
        { text: "Approve", value: "action" }
      ],

      filterslots: [
        { text: "All", value: '', class: "text-approved" },
        { text: "Approved", value: 1, class: "text-approved" },
        { text: "Declined", value: 2, class: "text-decline" },
        { text: "Pending", value: 0, class: "text-pending" }
      ],

      slots: [
        { text: "Approved", value: 1, class: "text-approved" },
        { text: "Declined", value: 2, class: "text-decline" },
        { text: "Pending", value: 0, class: "text-pending" }
      ],

      rejectionReasons: [
        "Invalid Payment Proof",
        "Insufficient Amount",
        "Wrong Account",
        "Other"
      ]
    }
  },

  methods: {
    ...mapActions("contest", [CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS, CONTEST__ACTIONS.UPDATECONTESTANTSTATUS]),

    handleClose(item) {
      this.$set(this.depositModal, item?.id, false)
      this.resetForm()
    },

    getTextColor(item) {
      return item.class
    },

    getStatusText(status) {
      switch (status) {
        case 0: return 'Pending'
        case 1: return 'Approved'
        case 2: return 'Rejected'
        default: return 'Unknown'
      }
    },

    showRejectionForm(item) {
      this.showRejectionCauseSection = true
      this.showButtons = false
    },

    cancelRejection() {
      this.resetForm()
    },

    resetForm() {
      this.showRejectionCauseSection = false
      this.showButtons = true
      this.selectedReason = null
      this.customReason = ""
    },

    async approveParticipant(item) {
      this[CONTEST__ACTIONS.UPDATECONTESTANTSTATUS]({
        id: item.id,
        clientname: item.name,
        clientemail: item.email,
        status: 1,
        contest_money: item.amount,
        transaction_id: item.transaction_id,
        contest_start: item.contest_start,
        contest_end: item.contest_end,
        client_account_id: item.client_account_id,
        trading_account_type_id: item.trading_account_type_id,
      })
      this.handleClose(item)
    },

    async confirmReject(item) {
      this[CONTEST__ACTIONS.UPDATECONTESTANTSTATUS]({
        id: item.id,
        clientname: item.name,
        clientemail: item.email,
        status: 2,
        contest_money: item.amount,
        transaction_id: item.transaction_id,
        contest_start: item.contest_start,
        contest_end: item.contest_end,
        client_account_id: item.client_account_id,
        trading_account_type_id: item.trading_account_type_id,
      })
      this.handleClose(item)
    },

    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    cancelSelection() {
      this.modal = false;
    },

    //created_at
    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Both start and end dates must be selected");
        return;
      }

      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        duration: `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
          }`,
      };

      this[CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS](parameter)

      this.modal = false;
      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },

    handleContestChange() {
      this[CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS]({
        contest_id: this.selectedContest
      })
    },

    handleContestStatus() {
      this[CONTEST__ACTIONS.ALLRUNNINGPARTICIPANTS]({
        status: this.selectedtStatus
      })
    },

    updateContestantStatus(item) {
      this[CONTEST__ACTIONS.UPDATECONTESTANTSTATUS]({
        id: item.id,
        clientname: item.name,
        clientemail: item.email,
        status: item.status,
        contest_money: item.amount,
        transaction_id: item.transaction_id,
        contest_start: item.contest_start,
        contest_end: item.contest_end,
        client_account_id: item.client_account_id,
        trading_account_type_id: item.trading_account_type_id,
      })
    },
  },
  mounted() {
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
}

</script>